import React from 'react';
import { EmptyState } from '../common/no-data-warning/empty-state';
import GenericWarnings from '../design/warning/GenericWarnings';
import { Sections } from '../sections/sections';
import { GenericWarning, PageDsl } from '../types';
import { UpsellWrapper } from '../common/upsell/upsell.wrapper';

const MainSection: React.FC<{
  dsl: PageDsl;
  showPageLevelNoDataWarning: boolean;
  globalWarnings: GenericWarning[];
  pageWarnings?: GenericWarning[];
}> = ({ dsl, showPageLevelNoDataWarning, globalWarnings, pageWarnings }) => {
  return (
    <>
      {showPageLevelNoDataWarning ? (
        <EmptyState />
      ) : (
        <>
          <GenericWarnings warnings={globalWarnings} />

          {dsl?.sections?.length > 0 && (
            <>
              {' '}
              <UpsellWrapper />
              <GenericWarnings warnings={pageWarnings} />
              <Sections sections={dsl.sections} />{' '}
            </>
          )}
        </>
      )}
    </>
  );
};

export default MainSection;
